import styled from "styled-components";

export const Container = styled.div`
width: 100%;
padding: 2rem;
display: flex;
flex-direction: column;
gap: 2rem;

.img{
  width: 4rem;
  border-radius: 50%;
}

td , th{
  width: 18rem !important;
  white-space: nowrap;
}

.th{
  width: 10rem !important;
}
`

export const StatusTabeContainer = styled.div`
width: 100%;
height: 9rem;
display: flex;
justify-content: start;
gap: 2rem;
align-items: center;
background-color:var(--white);
padding: 2rem;
z-index: 10;


`

export const CardContainer = styled.div`
  width: 100%;
  background-color:var(--white);
  display: flex;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  height: 45rem;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1336px) {
    height: auto;
  }

  .user-profile{
    width: 100%;
    text-align: start;
    display: flex;
    justify-content: start;
    align-items: center;
    margin: 16px;
    gap: 16px;
    font-size: 23px;
    color: #2e4d55;
    position: relative;
    top: -100px;
    z-index: 9;
    // right: -50px;

      @media (max-width: 520px) {
      flex-direction: column;
  }
  }
  .user-detail{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    position: relative;
    /* top: 8px; */
    gap: 1rem;
    width: 100%;

    h1{
      font-size:2.9rem;
      color:var(--white);
      position: relative; 

           @media (max-width: 520px) {
      color: #2e4d55;
  }
    }
    
    p{
      font-weight: 500;
      color: var(--text);
    }

  }

  .contect-list{
    width: 100%;
    display: flex;
    gap: 5rem;
        justify-content: space-between;
   @media (max-width: 960px) {
    flex-direction: column;
    gap: 2rem ;
   }
   div{
    display: flex;
    gap: 10px;
   }
  }

  .info-row{
    display: flex;
    gap: .5rem;
  }

  .info-detail{
    display: flex;
    gap: 1.5rem;
    align-items: center;
    p{
      font-size: 1.6rem;
      font-weight: 400;
      color: #A9A9A9;
    }
  }

  .retailer-bg-img {
  width: 100%;
  height: 212px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
    display: block;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4); // 🔹 black with 40% opacity
    border-radius: 15px;
    z-index: 1;
  }

  img {
    position: relative;
    z-index: 0;
  }
}

`;

export const Status = styled.span<{active:string}>`
padding: 0.5rem 1rem !important;
border-radius: 0.5rem;
background-color: ${({active})=>active === 'Complete' ? '#209A421A' : active === 'Pending' ? '#8B562533': active === 'Declined' ? '#E2383A1A' :''};
color: ${({active})=>active === 'Complete' ? 'var(--primary)' : active === 'Pending' ? '#8B5625': active === 'Declined' ? '#FF0000' :''};
/* width: 10rem; */
font-size: 1.2rem;
`